import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-795602a0")

_pushScopeId("data-v-795602a0")
const _hoisted_1 = { class: "row mb-4 mt-3" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "card dashboard-top-card border-left-success shadow h-100 py-2 no-pointer" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row no-gutters align-items-center" }
const _hoisted_6 = { class: "col mr-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-success text-uppercase mb-1" }, " Fiat Revenue ", -1)
const _hoisted_8 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fas fa-fas fa-money-bill-alt fa-2x text-gray-300" })
], -1)
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "card dashboard-top-card border-left-warning shadow h-100 py-2 no-pointer" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row no-gutters align-items-center" }
const _hoisted_14 = { class: "col mr-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-warning text-uppercase mb-1" }, " Crypto Revenue ", -1)
const _hoisted_16 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fab fa-btc fa-2x text-gray-300" })
], -1)
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = { class: "card dashboard-top-card border-left-success shadow h-100 py-2 no-pointer" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "row no-gutters align-items-center" }
const _hoisted_22 = { class: "col mr-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-success text-uppercase mb-1" }, " Total Revenue ", -1)
const _hoisted_24 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fas fa-fas fa-money-bill-alt fa-2x text-gray-300" })
], -1)
const _hoisted_26 = {
  id: "filters",
  class: "row animated fadeIn mt-5 mb-5"
}
const _hoisted_27 = { class: "col-xl-4 col-md-6" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-sm-6 col-md-6 col-lg-4" }
const _hoisted_30 = { class: "col-sm-6 col-md-6 col-lg-8" }
const _hoisted_31 = { class: "col-xl-3 col-md-6 col-sm-12 d-flex" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "mt-2 mr-2" }, "From:", -1)
const _hoisted_33 = { class: "col-xl-3 col-md-6 col-sm-12 d-flex" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "mt-2 mr-2" }, "To:", -1)
const _hoisted_35 = { class: "col-xl-2 col-md-2 col-sm-12" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_38 = { class: "col-xl-6 col-lg-6 col-md-12" }
const _hoisted_39 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("b", { class: "text-success" }, " Revenues Per Assets ")
], -1)
const _hoisted_40 = { class: "col-xl-6 col-lg-6 col-md-12" }
const _hoisted_41 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("b", { class: "text-success" }, " Percentage Of Revenues ")
], -1)
const _hoisted_42 = {
  key: 0,
  class: "col-12"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("small", null, "List of assets unabled for Coingecko Service: ", -1)
const _hoisted_44 = { class: "col-xl-12 col-lg-12 col-md-12 mt-5" }
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" No assets. ")
const _hoisted_47 = { class: "col-xl-6 col-lg-6 col-md-12" }
const _hoisted_48 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("b", { class: "text-success" }, " Revenues Per Assets ")
], -1)
const _hoisted_49 = { style: {"flex":"1"} }
const _hoisted_50 = { style: {"flex":"1"} }
const _hoisted_51 = { style: {"flex":"1"} }
const _hoisted_52 = { style: {"flex":"1"} }
const _hoisted_53 = { class: "col-xl-6 col-lg-6 col-md-12" }
const _hoisted_54 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("b", { class: "text-success" }, " Percentage Of Revenues ")
], -1)
const _hoisted_55 = { style: {"flex":"1"} }
const _hoisted_56 = { style: {"flex":"1"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_apexchart = _resolveComponent("apexchart")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.currentCurrencyConvert) + "$ " + _toDisplayString(_ctx.formatPrice(_ctx.getFiatRevenue)), 1)
              ]),
              _hoisted_9
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.currentCurrencyConvert) + "$ " + _toDisplayString(_ctx.formatPrice(_ctx.getCryptoRevenue)), 1)
              ]),
              _hoisted_17
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.currentCurrencyConvert) + "$ " + _toDisplayString(_ctx.formatPrice(_ctx.getFiatRevenue + _ctx.getCryptoRevenue)), 1)
              ]),
              _hoisted_25
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_CardBase, {
      title: "Currency Report",
      subtitle: "Get the sum of all assets into Satstreet customers."
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _createVNode("h3", null, "$ " + _toDisplayString(_ctx.currentCurrencyConvert), 1)
              ]),
              _createVNode("span", _hoisted_30, [
                _createVNode("button", {
                  class: ["btn", { 'btn-primary': _ctx.period == '1D' }],
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeInterval('1D')))
                }, " 1 D ", 2),
                _createVNode("button", {
                  class: ["btn", { 'btn-primary': _ctx.period == '1W' }],
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeInterval('1W')))
                }, " 1 W ", 2),
                _createVNode("button", {
                  class: ["btn", { 'btn-primary': _ctx.period == '1M' }],
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeInterval('1M')))
                }, " 1 M ", 2),
                _createVNode("button", {
                  class: ["btn", { 'btn-primary': _ctx.period == '3M' }],
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeInterval('3M')))
                }, " 3 M ", 2)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            _withDirectives(_createVNode("input", {
              class: "form-control",
              type: "date",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.from = $event))
            }, null, 512), [
              [_vModelText, _ctx.from]
            ])
          ]),
          _createVNode("div", _hoisted_33, [
            _hoisted_34,
            _withDirectives(_createVNode("input", {
              class: "form-control",
              type: "date",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.to = $event))
            }, null, 512), [
              [_vModelText, _ctx.to]
            ])
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode("button", {
              disabled: _ctx.isChangingIntervals,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeInterval())),
              class: "btn btn-block btn-primary"
            }, [
              _hoisted_36,
              _hoisted_37
            ], 8, ["disabled"])
          ])
        ]),
        (!_ctx.isLoadingPieChart && !_ctx.isChangingIntervals)
          ? (_openBlock(), _createBlock("div", {
              class: "row align-items-center",
              key: _ctx.charKey
            }, [
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_apexchart, {
                  type: "bar",
                  height: "350",
                  ref: "bar-chart",
                  options: _ctx.barChartOptions,
                  series: [{ data: _ctx.barSeries }]
                }, null, 8, ["options", "series"])
              ]),
              _createVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode(_component_apexchart, {
                  type: "donut",
                  ref: "donut-chart",
                  series: _ctx.pieSeries,
                  options: _ctx.pieChartOptions
                }, null, 8, ["series", "options"])
              ]),
              (_ctx.skipedAssets.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_42, [
                    _hoisted_43,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skipedAssets, (asset) => {
                      return (_openBlock(), _createBlock("span", {
                        key: asset.id,
                        class: "badge badge-dark ml-1"
                      }, _toDisplayString(asset.id), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_44, [
                _createVNode(_component_DataTable, {
                  class: "table-striped p-datatable-sm",
                  value: _ctx.getFilteredRevenues,
                  rows: 10,
                  rowsPerPageOptions: [10, 20, 50],
                  autoLayout: true,
                  paginator: true,
                  paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                  currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
                }, {
                  header: _withId(() => [
                    _createVNode("div", _hoisted_45, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control w-50",
                        placeholder: "Search...",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.mainSearch = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.mainSearch]
                      ])
                    ])
                  ]),
                  empty: _withId(() => [
                    _hoisted_46
                  ]),
                  default: _withId(() => [
                    _createVNode(_component_Column, { header: "Asset" }, {
                      body: _withId((slotProps) => [
                        _createVNode("b", null, _toDisplayString(slotProps.data.currency.id), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Base Revenues" }, {
                      body: _withId((slotProps) => [
                        _createVNode("code", null, _toDisplayString(slotProps.data.currency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(slotProps.data.baseRevenues)
                      : _ctx.formatZeros(
                          slotProps.data.baseRevenues,
                          slotProps.data.currency.exact
                        )), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Quote Revenues" }, {
                      body: _withId((slotProps) => [
                        _createVNode("code", null, _toDisplayString(slotProps.data.currency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(slotProps.data.quoteRevenues)
                      : _ctx.formatZeros(
                          slotProps.data.quoteRevenues,
                          slotProps.data.currency.exact
                        )), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Total Revenues" }, {
                      body: _withId((slotProps) => [
                        _createVNode("code", null, _toDisplayString(slotProps.data.currency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(slotProps.data.totalRevenues)
                      : _ctx.formatZeros(
                          slotProps.data.totalRevenues,
                          slotProps.data.currency.exact
                        )), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isLoadingPieChart || _ctx.isChangingIntervals)
          ? (_openBlock(), _createBlock("div", {
              key: _ctx.charKey,
              class: "row"
            }, [
              _createVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode("div", _hoisted_49, [
                  _createVNode(_component_Skeleton, {
                    width: "100%",
                    class: "mb-2"
                  }),
                  _createVNode(_component_Skeleton, { width: "75%" })
                ]),
                _createVNode("div", _hoisted_50, [
                  _createVNode(_component_Skeleton, {
                    width: "100%",
                    class: "mb-2"
                  }),
                  _createVNode(_component_Skeleton, { width: "75%" })
                ]),
                _createVNode("div", _hoisted_51, [
                  _createVNode(_component_Skeleton, {
                    width: "100%",
                    class: "mb-2"
                  }),
                  _createVNode(_component_Skeleton, { width: "75%" })
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode(_component_Skeleton, {
                    width: "100%",
                    class: "mb-2"
                  }),
                  _createVNode(_component_Skeleton, { width: "75%" })
                ])
              ]),
              _createVNode("div", _hoisted_53, [
                _hoisted_54,
                _createVNode(_component_Skeleton, {
                  width: "100%",
                  height: "150px"
                }),
                _createVNode("div", _hoisted_55, [
                  _createVNode(_component_Skeleton, {
                    width: "100%",
                    class: "mb-2"
                  }),
                  _createVNode(_component_Skeleton, { width: "75%" })
                ]),
                _createVNode("div", _hoisted_56, [
                  _createVNode(_component_Skeleton, {
                    width: "100%",
                    class: "mb-2"
                  }),
                  _createVNode(_component_Skeleton, { width: "75%" })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})